import Tags from '@/components/customercenter-ui/components/tags';
import { clearanceTextClass } from '@/helpers/utils/brandButton';
import { CurrencyHelpers } from '@/helpers/utils/currencyHelpers';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { getSelectedSite } from '@/helpers/utils/siteUtils';
interface Props {
  initialColor: any;
  initialSize: any;
  locale: any;
  showPromoRangeDiscount?: boolean;
}
export const Price: React.FC<Props> = ({ initialColor, initialSize, locale, showPromoRangeDiscount = true }) => {
  const getCurrencyValueObj = (obj: any, newAmount: number) => {
    const newObj = { ...obj };
    if (newObj) {
      newObj['centAmount'] = newAmount;
    }
    return newObj;
  };
  const getSalePriceDifference = (oldPrice: any, newPrice: any) => {
    const diff = oldPrice?.centAmount - newPrice?.centAmount;
    return { ...oldPrice, centAmount: diff };
  };

  const isPromoRangeDifferent =
    JSON.stringify(initialColor?.priceRange) !== JSON.stringify(initialColor?.promoPriceRange);

  const isOnSale = initialSize?.price?.activePriceType === 'CP' || initialSize?.price?.activePriceType === 'PP';
  const isNLP = initialSize?.price?.activePriceType === 'NLP';
  const siteId = getSelectedSite() ?? 'ZBSite';

  return (
    <span className="block">
      <Tags activePriceType={initialSize?.price?.activePriceType} overrideTagLabel={initialSize?.price?.priceLabel} />
      <section className="flex items-center gap-x-1">
        {initialSize && (
          <span
            className={`text-[22px] leading-5 ${
              isOnSale
                ? `font-bold ${clearanceTextClass(siteId)}`
                : 'text-black' + (isNLP ? ' font-bold' : ' font-normal')
            }`}
          >
            {CurrencyHelpers.formatForCurrency(initialSize?.price?.value, false, locale)}{' '}
          </span>
        )}
        {(isOnSale || isNLP) && (
          <span className="text-base font-normal text-[#656668] line-through">
            {initialColor?.priceRange && !initialColor?.promoPriceRange
              ? CurrencyHelpers.formatForCurrency(
                  getCurrencyValueObj(initialSize?.price?.value, initialColor?.priceRange?.minPriceCentAmount),
                  false,
                  locale,
                ) +
                ' - ' +
                CurrencyHelpers.formatForCurrency(
                  getCurrencyValueObj(initialSize?.price?.value, initialColor?.priceRange?.maxPriceCentAmount),
                  false,
                  locale,
                )
              : CurrencyHelpers.formatForCurrency(initialSize?.price?.listPrice, false, locale)}{' '}
          </span>
        )}
        {showPromoRangeDiscount && isPromoRangeDifferent && initialColor?.promoPriceRange && (
          <span
            className={`block text-base leading-5 ${
              !initialColor?.priceRange ? `font-bold ${clearanceTextClass(siteId)}` : 'font-normal text-black'
            }`}
          >
            {CurrencyHelpers.formatForCurrency(
              getCurrencyValueObj(initialSize?.price?.value, initialColor?.promoPriceRange?.minPriceCentAmount),
              false,
              locale,
            )}{' '}
            -{' '}
            {CurrencyHelpers.formatForCurrency(
              getCurrencyValueObj(initialSize?.price?.value, initialColor?.promoPriceRange?.maxPriceCentAmount),
              false,
              locale,
            )}{' '}
            {initialColor?.priceRange && (
              <span className="text-sm text-[#656668] line-through">
                {CurrencyHelpers.formatForCurrency(
                  getCurrencyValueObj(initialSize?.price?.value, initialColor?.priceRange?.minPriceCentAmount),
                  false,
                  locale,
                )}{' '}
                -{' '}
                {CurrencyHelpers.formatForCurrency(
                  getCurrencyValueObj(initialSize?.price?.value, initialColor?.priceRange?.maxPriceCentAmount),
                  false,
                  locale,
                )}
              </span>
            )}
          </span>
        )}
        {!isPromoRangeDifferent && initialColor?.priceRange && initialSize && (
          <span className="text-base font-normal leading-5 text-[#656668]">
            (
            {CurrencyHelpers.formatForCurrency(
              getCurrencyValueObj(initialSize?.price?.value, initialColor?.priceRange?.minPriceCentAmount),
              false,
              locale,
            )}{' '}
            -{' '}
            {CurrencyHelpers.formatForCurrency(
              getCurrencyValueObj(initialSize?.price?.value, initialColor?.priceRange?.maxPriceCentAmount),
              false,
              locale,
            )}
            )
          </span>
        )}
      </section>
      {isOnSale && (
        <span className={`block text-sm font-normal ${clearanceTextClass(siteId)}`}>
          {mapLocaleToMeaningfulFormat().save}{' '}
          {CurrencyHelpers.formatForCurrency(
            getSalePriceDifference(initialSize?.price?.listPrice, initialSize?.price?.value),
            false,
            locale,
          )}{' '}
          (
          {(
            ((initialSize?.price?.listPrice?.centAmount - initialSize?.price?.value?.centAmount) * 100) /
            initialSize?.price?.listPrice?.centAmount
          )
            ?.toFixed(2)
            .replace(/\.00$/, '')}
          %)
        </span>
      )}
    </span>
  );
};
